"use client";

import React from "react";
import { ShieldCheck, Sparkles, Wrench } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  icon: ShieldCheck,
  title: "Trasparenza",
  description: "Un'amministrazione aperta, dove ogni decisione è chiara e accessibile a tutti i cittadini."
}, {
  icon: Sparkles,
  title: "Competenza",
  description: "Esperienza e professionalità al servizio della comunità per una gestione efficace del bene comune."
}, {
  icon: Wrench,
  title: "Presenza",
  description: "Essere sul territorio, ascoltando i quartieri e vivendo quotidianamente le sfide di Albano."
}];
export default function EcosystemFeatures() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224521" id="i-nostri-valori" className="dark bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold font-default tracking-tight mb-4 text-foreground">
            I Nostri Valori
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            I pilastri su cui costruiamo il futuro di Albano, con integrità e dedizione istituzionale.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 lg:gap-16">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          const number = (i + 1).toString().padStart(2, '0');
          return <div key={i} data-index={i} className={`flex flex-col items-center text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <div className="relative w-24 h-24 bg-primary/5 flex items-center justify-center mb-6 border-b-2 border-primary/20">
                  <span className="absolute inset-0 flex items-center justify-center text-5xl font-bold font-default text-primary/10 select-none">
                    {number}
                  </span>
                  <Icon className="w-10 h-10 text-primary relative z-10" strokeWidth={1.5} />
                </div>
                <h3 className="text-2xl font-bold font-default mb-3 text-foreground">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed max-w-sm font-default">
                  {feature.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}